const teamNameShort = (team_index) => {
    const teams = ['PUO', 'Toezichthouder', 'Media'];
    if (typeof (team_index) !== 'number' || team_index < 0 || team_index >= teams.length) {
        return 'Onbekend';
    }
    return teams[team_index];
};

const teamName = (team_index) => {
    if (typeof (team_index) !== 'number') {
        return 'Onbekend';
    }
    return 'Verantwoordelijke ' + teamNameShort(team_index);
};

export default {
    teamName: teamName,
    teamNameShort: teamNameShort
}